/**
 * Parse a float value from a string. If the parse fails, we return the default value instead.
 *
 * This is useful for dealing with the strings returned by `<input>`s.
 * Also handles comma-formatted numbers (e.g., "1,075.00") and accepts number/null/undefined values.
 */
export function parseFloatOrFallback(
  value: string | number | null | undefined,
  defaultValue: number
): number {
  if (value == null) return defaultValue;
  if (typeof value === 'number') return value;

  try {
    // Remove commas before parsing (handles formatted numbers like "1,075.00")
    const cleaned = String(value).replace(/,/g, '');
    const parsedValue = parseFloat(cleaned);
    return isNaN(parsedValue) ? defaultValue : parsedValue;
  } catch {
    return defaultValue;
  }
}
